import React from 'react';
import { Box, AppBar, Toolbar, styled, Stack, IconButton } from '@mui/material';
import Profile from './Profile.tsx';
import { IconMenu2 } from '@tabler/icons-react';
import NotificationBell from '@/features/notifications/NotificationBell';
import NotificationsDrawer from '@/features/notifications/NotificationsDrawer';
import {
  useListNotifications,
  useMarkNotificationAsRead,
  useMarkAllNotificationsAsRead,
} from '@/lib/api/notifications';

const AppBarStyled = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  background: theme.palette.background.paper,
  justifyContent: 'center',
  backdropFilter: 'blur(4px)',
  zIndex: theme.zIndex.appBar,
  [theme.breakpoints.up('lg')]: {
    minHeight: '70px',
    left: '270px', // Start after sidebar width
    width: 'calc(100% - 270px)', // Take remaining width
  },
  // Full width on mobile
  [theme.breakpoints.down('lg')]: {
    left: 0,
    width: '100%',
  },
}));
const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  width: '100%',
  maxWidth: '100vw',
  color: theme.palette.text.secondary,
  overflowX: 'hidden',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  boxSizing: 'border-box',
}));

interface ItemType {
  toggleMobileSidebar: (event: React.MouseEvent<HTMLElement>) => void;
}

const Header = ({ toggleMobileSidebar }: ItemType) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { data: notifications = [] } = useListNotifications();
  const markOneMutation = useMarkNotificationAsRead();
  const markAllMutation = useMarkAllNotificationsAsRead();
  const unreadCount = notifications.filter((n) => !n.readAt).length;

  const handleMarkAsRead = (id: string) => {
    markOneMutation.mutate(id);
  };

  const handleMarkAllAsRead = () => {
    markAllMutation.mutate();
  };

  return (
    <AppBarStyled position="fixed" color="default">
      <ToolbarStyled>
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={toggleMobileSidebar}
          sx={{
            display: {
              lg: 'none',
              xs: 'inline',
            },
            padding: '12px',
            '& svg': {
              width: '24px',
              height: '24px',
            },
          }}
        >
          <IconMenu2 />
        </IconButton>

        <Box flexGrow={1} />
        <Stack spacing={1} direction="row" alignItems="center">
          <NotificationBell unreadCount={unreadCount} onClick={() => setDrawerOpen(true)} />
          <Profile />
        </Stack>
        <NotificationsDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          notifications={notifications}
          onMarkAsRead={handleMarkAsRead}
          onMarkAllAsRead={handleMarkAllAsRead}
        />
      </ToolbarStyled>
    </AppBarStyled>
  );
};

export default Header;
